import React, { useState } from "react";
import { Copyright } from "@mui/icons-material";
import { Alert, AlertTitle, Box, Button, IconButton, Link } from "@mui/material";

import analytics from "fond/analytics";
import { Modal } from "fond/widgets";

const DataCitations: React.FC = () => {
  const [showCitations, setShowCitations] = useState(false);

  return (
    <>
      <IconButton
        component="span"
        onClick={(event) => {
          event.stopPropagation();
          setShowCitations(true);
          analytics.track("project.market-lens.citations.open");
        }}
        disableFocusRipple
        disableRipple
        title="Show data citations"
        color="primary"
        sx={{ padding: 0 }}
      >
        <Copyright style={{ fontSize: "1rem" }} />
      </IconButton>

      <Modal
        open={showCitations}
        onClose={() => setShowCitations(false)}
        header="Data citations"
        content={
          <>
            <Box mb={2}>
              <Alert severity="info" variant="compact">
                <AlertTitle>National Broadband Map</AlertTitle>
                <p>
                  <b>Source data:</b>{" "}
                  <Link href="https://broadbandmap.fcc.gov/home" target="_blank">
                    FCC Broadband Data Collection
                  </Link>
                </p>
                <p>Map layers based on FCC BDC, presented as an aggregation at the census block level.</p>
              </Alert>
            </Box>

            <Box mb={2}>
              <Alert severity="info" variant="compact">
                <AlertTitle>Soil</AlertTitle>
                <p>
                  <b>Source data:</b> Soil Survey Geographic Database (SSURGO), provided by Natural Resources Conservation Service, United States
                  Department of Agriculture.
                </p>
                <p>
                  Accessed via{" "}
                  <Link href="https://www.nrcs.usda.gov/resources/data-and-reports/ssurgo-portal" target="_blank">
                    SSURGO Portal
                  </Link>{" "}
                  and bulk download resources, March 2024.
                </p>
              </Alert>
            </Box>

            <Box>
              <Alert severity="info" variant="compact">
                <AlertTitle>Demographics</AlertTitle>
                <p>
                  <b>Source data:</b> United States Census Bureau, American Community Survey.
                </p>
                <p>Map layer statistics are an analysis of the original census data, aggregated at the census block group level.</p>
              </Alert>
            </Box>
          </>
        }
        actions={<Button onClick={() => setShowCitations(false)}>Close</Button>}
      />
    </>
  );
};

export default DataCitations;
